import { ReactNode, useEffect } from 'react';
import { App } from '../api/apps';
import { useApp } from '../hooks/useApp';
import { useAuth } from '../auth/AuthContext';
import { Alert, Box, Loader } from '@mantine/core';
import { toast } from 'react-toastify';

export const WithApp = ({
  shortCode,
  optional,
  children,
}: {
  shortCode: string;
  optional: boolean;
  children: (app: App | null) => ReactNode;
}) => {
  const auth = useAuth();
  const { app, error } = useApp(auth?.token, shortCode);

  useEffect(() => {
    error && toast.error(error);
  }, [error]);

  return (
    <Box>
      {error && !optional ? (
        <Alert>{error}</Alert>
      ) : app || optional ? (
        children(app)
      ) : (
        <Loader />
      )}
    </Box>
  );
};
